// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"2d384944","958":"0b905de4"}[chunkId] + ".chunk.js";
};